import { render } from "./EmailTransactionPage.vue?vue&type=template&id=ec0a107e&scoped=true"
import script from "./EmailTransactionPage.vue?vue&type=script&lang=js"
export * from "./EmailTransactionPage.vue?vue&type=script&lang=js"

import "./EmailTransactionPage.vue?vue&type=style&index=0&id=ec0a107e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0a107e"]])

export default __exports__